module.exports = __webpack_public_path__ + "img/prj09.2a3e2ee8.png";